export default __webpack_public_path__ + "static/media/rank_man.62e32cd1.svg";